const message = {
  msg_1: 'News',
  msg_2: 'Previous page',
  msg_3: `Next page`,
}

export default message